import { fmt } from "../../format";
import { useNow } from "../../hooks";

export interface RelativeTimeProps {
  value: string | null | undefined;
  /** Text when there is no value. */
  fallback?: string;
  className?: string;
}

/** "5 minutes ago", with the exact date and time (America/Santiago) on hover. */
export function RelativeTime({ value, fallback = "—", className }: RelativeTimeProps): React.JSX.Element {
  const now = useNow();
  if (!value) return <span className={`nb-cell-muted${className ? ` ${className}` : ""}`}>{fallback}</span>;
  return (
    <time dateTime={value} title={fmt.dateTimeFull(value)} className={className}>
      {fmt.relative(value, Math.max(now, Date.now() - 1000))}
    </time>
  );
}
